<div class="sort-container">
  <ng-container class="sort-row" *ngFor="let data of sortData;">
    <span class="header-name"> {{ data.headerName }} </span>
    <span> {{ data.sort }} </span>
  </ng-container>
</div>
<div class="action-button">
  <nv-button type="tertiary" size="normal" (clickButton)="onClearAll()">Clear all</nv-button>
</div>
